import React, { useEffect, useState } from 'react';
import JSCookies from 'js-cookie';
import { useAffiliate } from '@havenengineering/module-shared-haven-ui-layout/dist/hooks/affiliate/useAffiliate';
import { handlePromo } from '../helpers/promo';
import { AFFILIATE_COOKIE_NAME } from '../constant';
import { getCampaignName } from './helper/get-campaign-name';

export const useFetchAffiliateData = (
  campaignId?: string | null,
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const [isPromoFetching, setPromoFetching] = useState(!!campaignId);
  const [isPromoProcessingCompleteWithoutErrors, setCompleteWithoutErrors] = useState(false);
  const [isPromoValidationComplete, setValidationComplete] = useState<
    'withPromoCode' | 'withoutPromoCode' | null
  >(null);
  const [campaignName, setCampaignName] = useState<string>('');
  const [promoCode, setPromoCode] = useState<string>('');

  const affiliate = useAffiliate({
    client: 'search',
    affiliateUrl: '',
  });

  const promoCookie = JSCookies.get(AFFILIATE_COOKIE_NAME);

  useEffect(() => {
    const initPromo = async () => {
      if (promoCookie || campaignId) {
        await fetchAffiliateData(promoCookie, campaignId);
        setValidationComplete('withPromoCode');

        if (campaignId) setCampaignName(getCampaignName(campaignId));
      } else {
        setPromoFetching(false);
        setValidationComplete('withoutPromoCode');
      }
    };

    initPromo();
  }, []);

  const fetchAffiliateData = async (promoCookie?: string, campaignId?: string | null) => {
    try {
      setPromoFetching(true);

      const { promoCode } = await handlePromo(promoCookie, campaignId);
      await affiliate.registerLink(new URLSearchParams(window.location.search));
      setPromoCode(promoCode);
      setCompleteWithoutErrors(true);
    } catch (err) {
      setCompleteWithoutErrors(false);
    }
    setPromoFetching(false);
    if (setLoading) setLoading(true);
  };

  return {
    isPromoFetching,
    isPromoProcessingCompleteWithoutErrors,
    isPromoValidationComplete,
    campaignName,
    promoCode,
  };
};
